export const trimJsonObject = (obj) => {
    // if (typeof obj !== 'object' || obj === null) {
    //     return obj;
    // }
    // for (let key in obj) {
    //     if (obj.hasOwnProperty(key)) {
    //         if (typeof obj[key] === 'string') {
    //             obj[key] = obj[key].trim();
    //         } else if (typeof obj[key] === 'object') {
    //             obj[key] = trimJsonObject(obj[key]);
    //         }
    //     }
    // }
    return obj;
}

export const commanArrayOfObjs=(array, key)=>{
    return (array?.filter((n)=> n?.value)).filter( (obj, index, self) => index === self.findIndex((o) => o[key] === obj[key]) );
}